/**
 * Validates a keyword entry.
 * Returns an error message string if invalid, or null if valid.
 */
export function validateKeyword(value, requiresNumericStart) {
    const trimmed = (value || '').trim();
    if (!trimmed) return null;
    if (requiresNumericStart && !/^\d/.test(trimmed)) {
        return 'Rules to Exclude must start with a numeric value';
    }
    return null;
}

/**
 * Returns a new alphabetically-sorted copy of the array.
 * Treats null/undefined as an empty array.
 */
export function sortAlphabetically(arr) {
    return [...(arr || [])].sort((a, b) => a.localeCompare(b));
}
